/**
 * @file   登录注册
 * @create macaiqi 2021/12/02
 * @update
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LoginModal } from '../LoginModal';
import { Button } from 'antd';
import Default from '@/assets/images/desktop/common/default.jpg';
import userPhoto from '@/assets/images/desktop/common/notLogin.png';
// import { openLoginModal, closeModal, openRegisterModal } from '../LoginModal/store';
import { openLoginModal, closeModal, logout } from '../LoginModal/store';
import './index.scss';
// 头部
const Login = () => {
  const dispatch = useDispatch();
  const { userInfo, open } = useSelector((state) => state.loginModalReducer);
  const handleOpenLoginModal = () => {
    dispatch(openLoginModal());
  };
  const handleLogOut = () => {
    dispatch(logout());
  };

  // 头部伸缩菜单
  const listArr = [
    {
      channel: 'Infor',
      name: '我的信息',
      icon: 'icon-wode'
    },
    {
      channel: 'Track',
      name: '浏览记录',
      icon: 'icon-zuji'
    },
    {
      channel: 'Collection',
      name: '收藏记录',
      icon: 'icon-shoucang'
    },
    {
      channel: 'DoStar',
      name: '点赞记录',
      icon: 'icon-good'
    }
    // {
    //   channel: 'ChangePassword',
    //   name: '修改密码',
    //   icon: 'icon-shoucang'
    // },
  ]
  return (
    <>
      {userInfo.id ? (
        <div className="user-box">
          <Link className="user-name" to="/PersonalPage">
            {/* {imgSrc && <img className={`avatar-logo ${cls}`} src={imgSrc} alt="" />}
            <Picture source={userInfo.fileId ? `${window.ENV_API}/file/getThumb/${userInfo.fileId}` : null} /> */}
            <img className={`avatar-logo `} src={Default} alt="" />
            <p className='text'>{userInfo.nickName ? userInfo.nickName : userInfo.username}</p>
          </Link>
          <ul className="user-list">
            {listArr.map(item => {
              return (
                <li key={item.channel}><Link to={`/PersonalPage/${item.channel}`}>{item.name}</Link></li>
              )
            })}
            <li onClick={handleLogOut}><Link to='/'>退出登录</Link></li>
          </ul>
        </div>
      ) : (
        // <Button className="login-button" type="link" onClick={handleOpenLoginModal}>
        //   登录
        // </Button>
        <img src={userPhoto}  onClick={handleOpenLoginModal}/>
      )}
      <LoginModal visible={open} onClose={() => dispatch(closeModal())} />
    </>
  )
};

export default Login;
